import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TFunction } from 'react-i18next';
import { Column } from 'react-table';
import OverflowTooltip from '../../OverflowTooltip/OverflowTooltip';
import { convertToUserFormat } from '../../../utils/dateWithTimezoneConversion';
import EmptyRowContent from '../../DataTable/EmptyRowContent';
import CallerInfo from '../../Calls/CallerInfo';
import TwoLineCell from '../../Calls/TwoLineCell';

export interface VoiceCallsTableRowInterface {
    id: string;
    accountId?: string;
    description?: string;
    comment?: string;
    connectTime?: string;
    chargedAmount?: number;
    celler?: string;
    destination?: string;
    chargedTime?: string;
}

export const useStyles = makeStyles(() => ({
    header: {
        '& th:nth-child(6)': {
            display: ' flex',
            justifyContent: 'end',
        },
    },

    tableContent: {
        '& td': {
            alignItems: 'center !important',
        },
        '& td:nth-child(6)': {
            display: 'flex',
            justifyContent: 'end',
        },
    },
}));

export const generateColumns = (
    t: TFunction<string>,
    currency = 'USD',
    userDateTimeFormat?: string,
): Column<VoiceCallsTableRowInterface>[] => {
    return [
        {
            Header: t<string>('screens:billing.accountID'),
            accessor: 'accountId',
            width: 1,
            Cell: function Cell(params) {
                const text = params.row.original.accountId;

                return (
                    <OverflowTooltip
                        tooltip={text}
                        text={text}
                        dataQa={'account-id-text'}
                        copy={false}
                    />
                );
            },
        },
        {
            Header: t<string>('screens:calls.callingNumber'),
            accessor: 'celler',
            width: 1,
            Cell: function Cell(params) {
                return <CallerInfo caller={params.row.original.celler!} />;
            },
        },
        {
            Header: t<string>('screens:calls.destination'),
            width: 1,
            accessor: 'destination',
            Cell: function Cell(params) {
                return <CallerInfo caller={params.row.original.destination!} />;
            },
        },

        {
            Header: t<string>('screens:calls.description'),
            width: 1,
            accessor: 'description',
            Cell: function Cell(params) {
                const desc = params.row.original.description;

                return (
                    <OverflowTooltip tooltip={desc} text={desc} copy={false} />
                );
            },
        },
        {
            Header: t<string>('screens:billing.connectChargedTime'),
            accessor: 'connectTime',
            width: 1.4,
            Cell: function Cell(params) {
                return params.row.original.connectTime ? (
                    <TwoLineCell
                        headerText={convertToUserFormat(
                            params.row.original.connectTime,
                            userDateTimeFormat,
                        )}
                        descriptionText={params.row.original.chargedTime?.toString()}
                    />
                ) : (
                    <EmptyRowContent />
                );
            },
        },

        {
            Header: t<string>('screens:billing.chargedWithCurrency', {
                currency: currency,
            }),
            width: 0.7,
            accessor: 'chargedAmount',
            Cell: function Cell(params) {
                return params.row.original.chargedAmount
                    ? params.row.original.chargedAmount.toFixed(2)
                    : Number(0).toFixed(2);
            },
        },
    ];
};
